// user
export const SET_USER_AUTH_HEADER = 'SET_USER_AUTH_HEADER'
export const SET_DATA_USER = 'SET_DATA_USER'
export const SET_FLUSH_USER = 'SET_FLUSH_USER'

// loading
export const START_LOADING = 'START_LOADING'
export const STOP_LOADING = 'STOP_LOADING'
export const APPLY_FULLSCREEN = 'APPLY_FULLSCREEN'
export const APPLY_COMPONENT = 'APPLY_COMPONENT'

// modal
export const START_MODAL = 'START_MODAL'
export const STOP_MODAL = 'STOP_MODAL'
export const LAUNCH_MODAL = 'LAUNCH_MODAL'
export const CLEAN_MODAL = 'CLEAN_MODAL'

// orders
export const SET_ORDERS_OPEN = 'SET_ORDERS_OPEN'
export const SET_AVAILABLE_ORDERS = 'SET_AVAILABLE_ORDERS'
export const SET_FLUSH_ORDERS = 'SET_FLUSH_ORDERS'
export const SET_FLUSH_AVAILABLE_ORDERS = 'SET_FLUSH_AVAILABLE_ORDERS'

// filters
export const SET_SELECTED_SUPPLIERORDERCODE = 'SET_SELECTED_SUPPLIERORDERCODE'
export const SET_SELECTED_SORT = 'SET_SELECTED_SORT'
export const SET_SELECTED_ORD = 'SET_SELECTED_ORD'
export const SET_ORDER_FILTERS = 'SET_ORDER_FILTERS'
export const SET_FLUSH_FILTERS = 'SET_FLUSH_FILTERS'
export const SET_SELECTED_PYXISDATA = 'SET_SELECTED_PYXISDATA'
export const SET_SELECTED_DISPONIBILITYDATA = 'SET_SELECTED_DISPONIBILITYDATA'
export const SET_AVAILABLE_ORDER_FILTERS = 'SET_AVAILABLE_ORDER_FILTERS'
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE'
export const RESET_SELECTED_PAGE = 'RESET_SELECTED_PAGE'
export const SET_STATES = 'SET_STATES'
export const SET_SELECTED_STATE = 'SET_SELECTED_STATE'
export const SET_DELIVERED_EFFECTIVE_STATUS = 'SET_DELIVERED_EFFECTIVE_STATUS'
export const SET_SELECTED_DELIVERED_EFFECTIVE_STATUS = 'SET_SELECTED_DELIVERED_EFFECTIVE_STATUS'

// items
export const LAUNCH_ITEMS_MODAL = 'LAUNCH_ITEMS_MODAL'
export const SET_FLUSH_ITEMS_MODAL = 'SET_FLUSH_ITEMS_MODAL'
export const START_ITEMS_MODAL = 'START_ITEMS_MODAL'
export const STOP_ITEMS_MODAL = 'STOP_ITEMS_MODAL'

// supplier
export const SET_SUPPLIER_EDF = 'SET_SUPPLIER_EDF'
export const SET_SELECTED_EDF_FEATURELIST = 'SET_SELECTED_EDF_FEATURELIST'
export const DEL_SELECTED_EDF_FEATURELIST = 'DEL_SELECTED_EDF_FEATURELIST'
export const SET_ALL_ACTIVE_SUPPLIERS = 'SET_ALL_ACTIVE_SUPPLIERS'
export const SET_REJECTIONS = 'SET_REJECTIONS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js